module.exports = __webpack_public_path__ + "img/categories6.ac69ab1e.jpg";